import { Component } from 'react';

class AccountInfoHolder extends Component {
  performSave = (userId, innerIndex, e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.performSave(userId, innerIndex, this.props.userIndex);
  };

  performUndelete = (userId, innerIndex, e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.performUndelete(userId, innerIndex, this.props.userIndex);
  };

  renderInfoField(leftTxt, rightTxt) {
    return (
      <tr className="info-field">
        <td className="left">{leftTxt} </td>
        <td className="right">{rightTxt}</td>
      </tr>
    );
  }

  onSlugChange(userObj, innerIndex, e) {
    const userId = userObj.id;
    userObj.slug = e.target.value;
    this.props.userObjUpdated(userId, userObj, innerIndex, this.props.userIndex);
  }

  renderUserBlock(userObj, index) {
    let privacyText;
    if (userObj.private == null || userObj.private == undefined) {
      privacyText = 'false';
    } else {
      privacyText = userObj.private.toString();
    }

    let statusTxt;
    let allowUndelete = false;
    if (userObj.status === 'R') {
      statusTxt = 'Active';
    } else if (userObj.status === 'D') {
      statusTxt = 'Deleted';
      allowUndelete = true;
    } else if (userObj.status === 'P') {
      statusTxt = 'Pending';
    }

    let locationTxt = '';
    if (userObj.location.city) {
      locationTxt += userObj.location.city;
    }
    if (userObj.location.region) {
      if (locationTxt.length > 0) {
        locationTxt += ', ';
      }
      locationTxt += userObj.location.region;
    }
    if (userObj.location.country) {
      if (locationTxt.length > 0) {
        locationTxt += ', ';
      }
      locationTxt += userObj.location.country;
    }
    return (
      <div>
        <table className="compare-container">
          <tbody>
            {this.renderInfoField('ID:', userObj.id)}
            {this.renderInfoField('Name:', `${userObj.firstName} ${userObj.lastName}`)}
            <tr className="info-field">
              <td className="left">Profile:</td>
              <td className="right">
                <a href={`/members/${userObj.slug}`} target="_blank">
                  Link
                </a>
              </td>
            </tr>
            <tr className="info-field">
              <td className="left">Slug:</td>
              <td className="right">
                <input
                  className="text-right"
                  style={{ border: 'solid 1px #ccc' }}
                  value={userObj.slug}
                  onChange={e => {
                    this.onSlugChange(userObj, index, e);
                  }}
                />
              </td>
            </tr>
            {this.renderInfoField('Email:', userObj.email)}
            {this.renderInfoField('Location:', locationTxt)}
            {this.renderInfoField('Pro:', userObj.pro ? userObj.pro.toString() : 'false')}
            {this.renderInfoField('Privacy:', privacyText)}
            {this.renderInfoField('Reviews:', userObj.reviews)}
            {this.renderInfoField('Photos:', userObj.photos)}
            {this.renderInfoField('Activities:', userObj.tracks)}
            <tr className="info-field">
              <td className="left">Account Status:</td>
              <td className="right">
                {statusTxt} {allowUndelete && <a onClick={e => this.performUndelete(userObj.id, index, e)}>(Undelete)</a>}
              </td>
            </tr>
            {this.renderInfoField('Following:', userObj.following)}
            {this.renderInfoField('Followers:', userObj.followers)}
          </tbody>
        </table>
        <div className="user-info-centered">
          <button className="btn green rounded simple" onClick={e => this.performSave(userObj.id, index, e)} type="button">
            Save
          </button>
        </div>
      </div>
    );
  }

  render() {
    let userInfoBlock = null;
    if (this.props.users.length > 0) {
      if (this.props.users[0].error) {
        userInfoBlock = <h3>{this.props.users[0].error}</h3>;
      } else {
        userInfoBlock = (
          <div>
            <h3>
              Found {this.props.users.length} user
              {this.props.users.length > 1 ? 's' : ''}
            </h3>
            {this.props.users.map((item, i) => this.renderUserBlock(item, i))}
          </div>
        );
      }
    }

    return <div>{userInfoBlock}</div>;
  }
}

export default AccountInfoHolder;
